export default {"card":"A5AB-","image":"nCsOg","tag":"HJgzi","texts":"re5qz","title":"U19Lv","price":"_7DFpv"};